import { useState } from "react";
import { api } from "@/api";
import { LogIn, Loader2 } from "lucide-react";

const formatError = (detail) => {
  if (!detail) return "Erreur de connexion. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md">
      <div className="bg-white/60 p-10 shadow-sm" data-testid="admin-login-card">
        <p className="text-xs uppercase tracking-[0.3em] text-clay">Espace privé</p>
        <h1 className="mt-3 font-serif text-3xl tracking-tight">Administration</h1>
        <p className="mt-3 text-sm text-bark">Connectez-vous pour gérer le contenu du site.</p>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label htmlFor="admin-email" className="text-xs uppercase tracking-[0.25em] text-taupe">Email</label>
            <input
              id="admin-email"
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full border-b border-bark/40 bg-transparent py-3 outline-none transition-[border-color] duration-300 focus:border-clay"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="text-xs uppercase tracking-[0.25em] text-taupe">Mot de passe</label>
            <input
              id="admin-password"
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full border-b border-bark/40 bg-transparent py-3 outline-none transition-[border-color] duration-300 focus:border-clay"
            />
          </div>
          {error && (
            <p className="bg-clay/10 px-4 py-3 text-sm text-clay" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-3 rounded-full bg-clay px-8 py-4 text-sm font-medium text-cream transition-[background-color,opacity] duration-300 hover:bg-ink disabled:opacity-60"
          >
            {busy ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />}
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
